import CommunicationLogs from '@/views/system/CommunicationLogs.vue'
import CronJobs from '@/views/system/CronJobs.vue'
import CronJob from '@/views/system/CronJob.vue'
import FailedEvents from '@/views/system/Events/Failed.vue'
import FailedJobs from '@/views/system/Jobs/Failed.vue'
import Issues from '@/views/system/Issues.vue'
import ScheduledEvents from '@/views/system/Events/Scheduled.vue'
import Status from '@/views/system/Status.vue'
import Test from '@/views/system/Test.vue'
import WorkingEvents from '@/views/system/Events/Working.vue'
import WorkingJobs from '@/views/system/Jobs/Working.vue'

import * as Breadcrumbs from '../breadcrumbs/system'

export default [
	{
		path: '/communication-logs',
		name: 'communication-logs',
		component: CommunicationLogs,
		meta: {
			requiresAuth: true,
			title: 'Communication Logs',
			breadcrumb: [
				Breadcrumbs.CommunicationLogs,
			],
		},
	},
	{
		path: '/events',
		name: 'events',
		component: FailedEvents,
		meta: {
			requiresAuth: true,
			title: 'System Events',
			breadcrumb: [
				Breadcrumbs.Events,
			],
		},
	},
	{
		path: '/events/working',
		name: 'events-working',
		component: WorkingEvents,
		meta: {
			requiresAuth: true,
			title: 'System Events',
			breadcrumb: [
				Breadcrumbs.Events,
				Breadcrumbs.EventsWorking,
			],
		},
	},
	{
		path: '/events/scheduled',
		name: 'events-scheduled',
		component: ScheduledEvents,
		meta: {
			requiresAuth: true,
			title: 'System Events',
			breadcrumb: [
				Breadcrumbs.Events,
				Breadcrumbs.EventsScheduled,
			],
		},
	},
	{
		path: '/jobs',
		name: 'jobs',
		component: FailedJobs,
		meta: {
			requiresAuth: true,
			title: 'System Jobs',
			breadcrumb: [
				Breadcrumbs.Jobs,
			],
		},
	},
	{
		path: '/jobs/working',
		name: 'jobs-working',
		component: WorkingJobs,
		meta: {
			requiresAuth: true,
			title: 'System Jobs',
			breadcrumb: [
				Breadcrumbs.Jobs,
				Breadcrumbs.JobsWorking,
			],
		},
	},
	{
		path: '/system-cron',
		name: 'system-cron',
		component: CronJobs,
		meta: {
			requiresAuth: true,
			title: 'Cron Jobs',
			breadcrumb: [
				Breadcrumbs.CronJobs,
			],
		},
	},
	{
		path: '/system-cron/:job',
		name: 'system-cron-job',
		component: CronJob,
		meta: {
			requiresAuth: true,
			title: 'Cron Jobs',
			breadcrumb: [
				Breadcrumbs.CronJobs,
				Breadcrumbs.CronJob,
			],
		},
	},
	{
		path: '/system-issues',
		name: 'system-issues',
		component: Issues,
		meta: {
			requiresAuth: true,
			title: 'Issues',
			breadcrumb: [
				Breadcrumbs.Issues,
			],
		},
	},
	{
		path: '/system-status',
		name: 'system-status',
		component: Status,
		meta: {
			requiresAuth: true,
			title: 'System Status',
			breadcrumb: [
				Breadcrumbs.Status,
			],
		},
	},
	{
		path: '/system-test',
		name: 'system-test',
		component: Test,
		meta: {
			requiresAuth: true,
			title: 'Manual Tests',
			breadcrumb: [
				Breadcrumbs.Test,
			],
		},
	},
]
